import { useState, useEffect } from 'react';
import { useGetRound } from '../context/PredictionsContext';

/**
 * Hook para contagem regressiva baseada no timestamp do round do contrato
 * @param {number} epoch - número do epoch que você quer observar (ex: currentEpoch)
 * @param {('lock'|'close')} type - tipo de timestamp: 'lock' ou 'close'
 * @param {Function} [onComplete] - função chamada quando a contagem chega a zero
 */
const useCountdown = (targetTimestamp, onComplete) => {

  const [countdown, setCountdown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    expired: false,
  });

  useEffect(() => {
    if (!targetTimestamp) {
      setCountdown({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        expired: false,
      });
      return;
    }

    const updateCountdown = () => {
      const now = Date.now();
      const distance = targetTimestamp - now;

      if (distance <= 0) {
        setCountdown({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
          expired: true,
        });
        if (onComplete) onComplete();
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setCountdown({
        days,
        hours,
        minutes,
        seconds,
        expired: false,
      });
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, [targetTimestamp, onComplete]);

  return countdown;
};

export default useCountdown;